import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ palette }) => ({
  navigation: {
    backgroundColor: palette.surface,
    padding: "20px 20px 20px 0",
    borderRight: "1px solid #CFDDE2",
  },
  sidebarItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "15px",
    cursor: "pointer",
    color: "#4A4A4A",
    padding: "0 5px",
    fontWeight: 500,
    textDecoration: "none",
    margin: "0 0 20px 23px",

    "& .icon": {
      marginRight: "5px",
    },
  },
  menuItemContainer: {
    display: "flex",
    borderBottom: "1px solid #d8d8d8",
  },
  menuItem: {
    display: "inline-block",
    color: "#4A4A4A",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 500,
    width: "auto",
    padding: "8px 16px",

    "& span": {
      display: "inline",
    },
  },
  activeMenuItem: {
    backgroundColor: "#F4F7F8",
  },
  chartWrapper: {
    width: "70%",
    padding: "20px",
  },
  chartTitle: {
    fontSize: "22px",
    color: "#4A4A4A",
    fontWeight: 400,
    marginBottom: "26px",
  },
  dropdown: {
    boxShadow: "1px 2px 4px 0px #00000033",
    display: "inline-block",
    borderRadius: "8px",
    padding: "8px 17px",
    cursor: "pointer",
    width: '200px',
  },
  dropdownContainer: {
    position: 'relative',
    marginRight: '21px',
  },
  dropdownOverlay: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  dropdownContent: {
    margin: "10px 0",
    position: 'absolute',
    top: '58px',
    left: 0,
    boxShadow: '1px 2px 4px 0px #00000033',
    borderRadius: '8px',
    padding: '10px 20px',
    backgroundColor: '#fff',
    width: '200px',
  },
  dropdownTitle: {
    color: "#4A4A4A",
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: 700,
    margin: 0,
  },
  dropdownSubtitle: {
    color: "#4A4A4A",
    fontSize: "14px",
    fontWeight: 400,
    margin: "5px 20px 5px 0 ",
    display: "inline-block",
  },
  dropdownIcon: {
    width: "6px",
  },
  dropDownBtn: {
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #00AAE9",
    background: "transparent",
    padding: "5px 10px",
    marginTop: "5px",
    borderRadius: "24px",
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#00AAE9",
    cursor: "pointer",
    transition: "0.3s ease",

    '&:hover': {
      backgroundColor: "#00AAE9",
      color: '#fff'
    },
  },
  dropdownLabel: {
    color: '#4A4A4A',
    fontSize: '14px',
    marginLeft: '2px',
    cursor: 'pointer',
  },
  dropdownItem: {
    margin: '5px 0',
    cursor: 'pointer',
    '& input': {
      cursor: 'pointer',
    }
  },
  dropdownFlex: {
    display: 'flex',
    justifyContent: 'space-between',

  },
  subitemMargin: {
    marginLeft: '17px'
  },
  buttonsContainer: {
    display: 'flex',
  },
  barWrapper: {
    marginTop: '20px'
  },

}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);

